import isScrollable from "../helper/checkScrollable";

const quickNav = () => {

	var tabs = jQuery('.c-quicknav').find('.c-quicknav__nav');
	const subnav = document.getElementById("subquicknav");

	if(tabs.is(':visible')) {

		jQuery('body,html').removeClass('uk-overflow-hidden');

		jQuery(document).click(function(e) {
			if (!jQuery(e.target).is('.c-quicknav, .c-quicknav *')) {
				tabs.find('a').parents('.c-quicknav__label').removeClass('--active');
				tabs.parents('.c-quicknav').find('.c-quicknav__content').removeClass('--active');
			}
		});

		tabs.find('a').unbind( 'click');
		tabs.find('a').on('click', function(event) {

			event.preventDefault();

			let target = jQuery(this).attr('href'),
				pos = Math.abs( Math.abs(jQuery(this).parents('.c-quicknav__nav').offset().left) - Math.abs(jQuery(this).offset().left)),
				tabs = jQuery(this).parents('.c-quicknav__nav'),
				buttons = tabs.find('a').parents('.c-quicknav__label'),
				item = tabs.parents('.c-quicknav').find('.c-quicknav__content'),
				active = (jQuery(this).parent().hasClass('--active') ? true : false);

				buttons.removeClass('--active');
				item.removeClass('--active');

				if(jQuery(this).data('main')) {
					subnav.setAttribute('hidden',true);
				}


				if(!active) {
					jQuery(this).parents('.c-quicknav__label').addClass('--active');
					jQuery(target).addClass('--active');
					jQuery(target).parents('.c-quicknav__content_wrap--auto').css('left', pos);
				}

        const scrollElm = document.querySelector(target + '.--active .c-quicknav__content__inner__content');
        if(scrollElm && isScrollable(scrollElm)) {
          scrollElm.classList.add('--scrollable');
        }


		});

    const filterScrollDowns = document.querySelectorAll('.c-filter__scrolling');
    filterScrollDowns.forEach(function(elm) {
      const scrollContainer = elm.closest('.c-quicknav__content__inner__content')
      if(scrollContainer) {
        scrollContainer.addEventListener('scroll',() => {
          if(scrollContainer.scrollTop > 50) {
            scrollContainer.classList.add('--scrollable-hidden');
          } else {
            scrollContainer.classList.remove('--scrollable-hidden');
          }
        });
        elm.addEventListener('click', () => {
          scrollContainer.scrollTop = 250;
        })
      }

    });

	} else {

		jQuery('.c-quicknav__content__label:not(.--range)').on('click', function() {

			var container = jQuery(this).parents('.c-quicknav'),
				content = jQuery(this).parent('.c-quicknav__content'),
				currId = content.attr('id'),
				items = container.find('.c-quicknav__content');

			container.find('.c-quicknav__nav a').removeClass('--active');
			items.removeClass('--active');
			jQuery('body,html').removeClass('uk-overflow-hidden');

			content.addClass('--active');
			container.find('.c-quicknav__nav a[href$="#'+ currId +'"]').addClass('--active');
			jQuery('body,html').addClass('uk-overflow-hidden');
			jQuery('.c-quicknav__footer').addClass('uk-hidden');

		});

		jQuery('.c-quicknav__content__close').on('click', function() {

			var container = jQuery(this).parents('.c-quicknav'),
				items = container.find('.c-quicknav__content');

				container.find('.c-quicknav__nav a').removeClass('--active');
				items.removeClass('--active');

				jQuery('body,html').removeClass('uk-overflow-hidden');
				setTimeout(function(){
          jQuery('.c-quicknav__footer').removeClass('uk-hidden');
        },300);

		});
	}

	// # layout switch

	jQuery(document).on('click','.c-filter__bar__layout__button', function(){
		if(jQuery(this).hasClass('active')) {
			return;
		}
		if(jQuery(this).data('style') == 'list'){
			jQuery('#filter_results').removeClass('filter--grid');
		} else {
			jQuery('#filter_results').addClass('filter--grid');
		}

		jQuery('.c-filter__bar__layout__button').toggleClass('active');
	});

	jQuery(document).on('focus','.c-filter--search input', function(){
		tabs.parents('.c-quicknav').find('.c-quicknav__content').removeClass('--active');
		tabs.find('a').parents('.c-quicknav__label').removeClass('--active');
	});

	jQuery(document).on('change','.c-filter--search input', function(){
		if(jQuery(this).val()!=""){
			jQuery('#search_reset').removeClass('uk-hidden');
		} else {
			jQuery('#search_reset').addClass('uk-hidden');
		}
	});

	jQuery(document).on('click','[data-subfilter="toggle"]', function(e){

    const label = e.target.closest('li');
    const button = label.querySelector('[data-subfilter-link]');
    const ref = button.dataset.subfilterLink;
    const subnavItems = subnav.querySelectorAll('[data-subfilter-ref]');

    subnavItems.forEach(item => {
      item.setAttribute('hidden',true);
    });

    if(!label.classList.contains('--active')) {
      subnav.setAttribute('hidden',true);
      subnavItems.forEach(item => {
        item.setAttribute('hidden',true);
      });
    } else {
      subnav.removeAttribute('hidden');
      const activeSubnavItems = subnav.querySelectorAll('[data-subfilter-ref="'+ref+'"]');
      activeSubnavItems.forEach(item => {
        item.removeAttribute('hidden');
      });
    }
	});

};

export default quickNav;
